import { getCookie, setCookie } from './helper-functions'


if (!getCookie('cookiesAccepted')){
  $('.js-cookies-popup').fadeIn()
}

$('.js-accept-cookies').click(function(){
  setCookie('cookiesAccepted', 1, 365)
  $('.js-cookies-popup').fadeOut()
})


$('.js-cancel-cookies').click(function(){
  $('.js-cookies-popup').fadeOut()
})

